import {Component, computed} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {FixedSchedulePlaceholder} from '@domain/planning-prototype/carpet/fixed-schedule-placeholder';
import {RunCarpet} from '@domain/planning-prototype/carpet/run-carpet';
import {PlanningItem} from '@domain/planning-prototype/planning-item';
import {AssertionUtils} from '@vdw/angular-component-library';
import moment, {Moment, duration} from 'moment';
import {filter} from 'rxjs';
import {PlanningPrototypeContextService, SelectedItemType} from '../../utilities/planning-prototype-context.service';
import {PlanningItemSidebarComponent} from '../planning-item-sidebar/planning-item-sidebar.component';

@Component({
  selector: 'app-fixed-schedule-placeholder-sidebar',
  templateUrl: './fixed-schedule-placeholder-sidebar.component.html',
  styleUrls: ['./fixed-schedule-placeholder-sidebar.component.scss']
})
export class FixedSchedulePlaceholderSidebarComponent {
  public readonly DURATION_FORMAT_STRING = 'd[d] h[h] m[m]';
  public readonly DURATION_FORMAT_OPTIONS: moment.DurationFormatSettings = {trim: 'both'};

  public readonly machine = computed(() => this.planningContext.machinesByPlanningItem[this.placeholder().draftId]);
  public readonly forecast = computed(() => this.planningContext.sortedPlanningItemForecasts[this.placeholder().draftId]);
  public readonly placeholder = toSignal(this.planningContext.selectedItemChanges.pipe(filter((item: SelectedItemType): item is FixedSchedulePlaceholder => item instanceof FixedSchedulePlaceholder)));
  public readonly parentRun = computed(
    () => this.planningContext.planningLinesByMachine[this.parent.machine.id].planningItems.find((item: PlanningItem) => item.planningItems.includes(this.placeholder())) as RunCarpet
  );

  public constructor(
    private readonly parent: PlanningItemSidebarComponent,
    private readonly planningContext: PlanningPrototypeContextService
  ) {}

  public getDuration(): string {
    let end: Moment;
    if (AssertionUtils.isNullOrUndefined(this.placeholder().actualEndDate)) {
      end = moment();
    } else {
      end = moment(this.placeholder().actualEndDate);
    }
    return duration(end.diff(moment(this.placeholder().actualStartDate))).format(this.DURATION_FORMAT_STRING, this.DURATION_FORMAT_OPTIONS);
  }

  public delete(): void {
    this.planningContext.delete(this.placeholder(), this.parentRun().planningItems, this.parent.machine);
  }
}
